// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ProductLinkFragmentDoc } from '../../../../router/fragments/productLink.fragment.generated';
export const ProductAnalyticsFragmentDoc = gql`
    fragment productAnalytics on CatalogueProduct {
  catalogueCode
  productName
  suffix
  segmentName
  salePrice(currency: $currency, country: $country) {
    total {
      currency
      amount
    }
  }
  primaryMetal {
    systemCode
    element {
      systemCode
    }
    millesimalFineness
    karat
    segmentName
  }
  ... on CatalogueEngagementRing {
    bandWidth
    segmentName
    deliveryDays(country: $country, hasEngraving: false)
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueReadyToGoRing {
    segmentName
    deliveryDays(country: $country)
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueWeddingRing {
    segmentName
    deliveryDays(country: $country, hasEngraving: false)
    categories {
      systemCode
    }
    translation(locale: $locale) {
      description
    }
    bandWidth
    ringStyles {
      systemCode
    }
    signatureStone {
      id
      width
      caratWeight
      shape {
        systemCode
        translation(locale: $locale) {
          name
        }
      }
      crystal {
        systemCode
        translation(locale: $locale) {
          name
        }
      }
      grade {
        systemCode
        translation(locale: $locale) {
          name
        }
      }
      colors {
        systemCode
        translation(locale: $locale) {
          name
        }
      }
      clarities {
        systemCode
        translation(locale: $locale) {
          name
        }
      }
    }
  }
  ... on CatalogueJewellery {
    segmentName
    jewellerySku: sku
    designStyles {
      systemCode
    }
  }
  ... on CatalogueJewelleryEarrings {
    deliveryDays(country: $country, hasEngraving: false)
    translation(locale: $locale) {
      description
    }
    earringsProductStyles: productStyles {
      systemCode
    }
  }
  ... on CatalogueJewelleryNecklace {
    deliveryDays(country: $country, hasEngraving: false)
    translation(locale: $locale) {
      description
    }
    necklaceProductStyles: productStyles {
      systemCode
    }
  }
  ... on CatalogueJewelleryBracelet {
    deliveryDays(country: $country, hasEngraving: false)
    translation(locale: $locale) {
      description
    }
    braceletProductStyles: productStyles {
      systemCode
    }
  }
  ... on CatalogueJewelleryRing {
    deliveryDays(country: $country, hasEngraving: false)
    translation(locale: $locale) {
      description
    }
    jewelleryRingProductStyles: productStyles {
      systemCode
    }
  }
}
    `;
export const ProductListAnalyticsFragmentDoc = gql`
    fragment productListAnalytics on CatalogueProduct {
  __typename
  catalogueCode
  segmentName
  ...productLink
  salePrice(currency: $currency, country: $country) {
    total {
      currency
      amount
    }
  }
  primaryMetal {
    segmentName
  }
  ... on CatalogueEngagementRing {
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueReadyToGoRing {
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueWeddingRing {
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueJewellery {
    jewellerySku: sku
  }
  ... on CatalogueJewelleryEarrings {
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueJewelleryNecklace {
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueJewelleryBracelet {
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueJewelleryRing {
    translation(locale: $locale) {
      description
    }
  }
}
    ${ProductLinkFragmentDoc}`;
export const GemsApiStoneAnalyticsFragmentDoc = gql`
    fragment gemsApiStoneAnalytics on GemsApi_Stone {
  crystalWithInfo {
    info {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  shapeWithInfo {
    info {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  colorWithInfo {
    info {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  clarityWithInfo {
    info {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  cutWithInfo {
    info {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  gradeWithInfo {
    info {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
  weight
  originCountry
}
    `;
export const NonSkuGemstoneAnalyticsFragmentDoc = gql`
    fragment nonSkuGemstoneAnalytics on NonSkuGemstone {
  crystal {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  shape {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  color {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  clarity {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  cut {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  colorGrade {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  caratWeight
}
    `;
export const NonSkuLabGrownAnalyticsFragmentDoc = gql`
    fragment nonSkuLabGrownAnalytics on NonSkuLabGrown {
  crystal {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  shape {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  color {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  clarity {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  cut {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  caratWeight
}
    `;